import React from "react";
import { useI18next } from "gatsby-plugin-react-i18next";

import ALink from "../common/ALink";
// import VietnameseFlag from "../../images/vn.svg";
import JapaneseFlag from "../../images/jp.svg";
import BrazilianFlag from "../../images/br.svg";

import "./LanguageSwitcher.css";
import Image from "./Image";

const showMenuClass = "show";

export default function LanguageSwitcher(props) {
  const { language, languages, originalPath } = useI18next();

  function myFunction(e) {
    const menu = document.getElementById("language-menu");

    if (menu.classList.contains(showMenuClass)) {
      menu.classList.remove(showMenuClass);
    } else {
      menu.classList.add(showMenuClass);
    }

    e.stopPropagation();
  }

  // Close the dropdown if the user clicks outside of it
  typeof window !== "undefined" &&
    (window.onclick = function (event) {
      if (!event.target.matches(".language-menu__current-language")) {
        var dropdowns = document.getElementsByClassName("language-menu");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
          }
        }
      }
    });

  function getInfo(language) {
    return language === "br"
      ? {
          icon: BrazilianFlag,
          text: "Português",
        }
      : {
          icon: JapaneseFlag,
          text: "日本語",
        };
  }

  function onChangeLanguage(lng) {
    const currentLanguageIcon = document.getElementById(
      "current-language__icon"
    );

    currentLanguageIcon.src = getInfo(lng).icon;
    props.onAfterChangeLanguage && props.onAfterChangeLanguage();
  }

  return (
    <div className="dropdown">
      <div className="language-menu__current-language" onClick={myFunction}>
        <Image
          id="current-language__icon"
          alt="Japanese"
          src={getInfo(language).icon}
        />

        <span className="language-menu__current-language-jp-vi">
          {getInfo(language).text}
        </span>
      </div>
      <div id="language-menu" className="language-menu">
        {languages.map((lng) => {
          return (
            <ALink
              to={originalPath}
              language={lng}
              onClick={(e) => onChangeLanguage(lng)}
            >
              <div className="language-menu__item">
                <Image
                  className="language-menu__flag-icon"
                  alt="Japanese"
                  src={getInfo(lng).icon}
                />
                <span>{getInfo(lng).text}</span>
              </div>
            </ALink>
          );
        })}
      </div>
    </div>
  );
}
